import { defineComponent as k, computed as g, createElementBlock as t, openBlock as s, createElementVNode as c, Fragment as p, renderList as y, normalizeClass as L, toDisplayString as u, createVNode as m, unref as l, withCtx as x } from "vue";
import { RevLink as v } from "@ds/components/Link";
import w from "../../icons/generated/IconArrowLeft.vue2.js";
import B from "../../icons/generated/IconChevronRight.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
const C = ["aria-label"], N = {
  class: "m-0 flex list-none items-center py-12 md:py-20",
  itemscope: "",
  itemtype: "http://schema.org/BreadcrumbList"
}, $ = {
  key: 0,
  "aria-current": "page",
  class: "body-2 truncate",
  itemprop: "name"
}, E = {
  class: "body-2-bold truncate",
  itemprop: "name"
}, V = ["content"], I = /* @__PURE__ */ k({
  name: "RevBreadcrumb",
  __name: "Breadcrumb",
  props: {
    breads: {},
    ariaLabel: {}
  },
  emits: ["click-breadcrumb"],
  setup(h, { emit: b }) {
    const n = h, _ = b, f = g(
      () => n.breads.map((i, r) => {
        const e = r === n.breads.length - 1, o = r === Math.max(n.breads.length - 2, 0), d = [
          a`text-action-default-hi md:flex`,
          e ? a`min-w-[6ch]` : a`md:shrink-0`,
          o ? a`min-w-0` : a`hidden`
        ];
        return { ...i, isLast: e, classNames: d };
      })
    );
    return (i, r) => (s(), t("nav", { "aria-label": i.ariaLabel }, [
      c("ol", N, [
        (s(!0), t(p, null, y(f.value, (e, o) => (s(), t("li", {
          key: e.title,
          class: L(e.classNames),
          itemprop: "itemListElement",
          itemscope: "",
          itemtype: "http://schema.org/ListItem"
        }, [
          e.isLast ? (s(), t("div", $, u(e.title), 1)) : (s(), t(p, { key: 1 }, [
            m(l(v), {
              class: "flex items-center whitespace-nowrap",
              itemprop: "item",
              to: e.link,
              tracking: e.tracking,
              underlined: !1,
              onClick: (d) => _("click-breadcrumb", e.title)
            }, {
              default: x(() => [
                m(l(w), { class: "mr-8 shrink-0 md:hidden" }),
                c("span", E, u(e.title), 1)
              ]),
              _: 2
            }, 1032, ["to", "tracking", "onClick"]),
            m(l(B), { class: "hidden md:mx-8 md:block" })
          ], 64)),
          c("meta", {
            content: `${o + 1}`,
            itemprop: "position"
          }, null, 8, V)
        ], 2))), 128))
      ])
    ], 8, C));
  }
});
export {
  I as default
};
